/* eslint-disable react/prop-types */
import React from 'react';
import IconButton from '@mui/material/IconButton';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import CloseIcon from '@mui/icons-material/Close';
import RestartAltIcon from '@mui/icons-material/RestartAlt';

const Header = ({ title, showReset, onReset, onClose, chatT }) => {

  return (
    <div className="ai-chat-widget-header">
      <div className="ai-chat-widget-header-left">
        <AutoAwesomeIcon className="ai-icon" />
        <span className="ai-chat-widget-title">{title}</span>
      </div>
      <div className="ai-chat-widget-header-right">
        {showReset && (
          <IconButton size="small" onClick={onReset} title={chatT('aiChat:buttons:startOver')}>
            <RestartAltIcon fontSize="small" />
          </IconButton>
        )}
        <IconButton size="small" onClick={onClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </div>
    </div>
  );
};

export default Header;

